import { pathJoin } from 'src/reducers/routing/utils'

export const createVerdisRoutesMap = (prefix: string) => ({
  'all-requests': pathJoin(prefix)('all-requests').chain,
  'agreement-container-updates': pathJoin(prefix)('agreement-container-updates')
    .chain,
  'agreement-container-files': pathJoin(prefix)('agreement-container-files')
    .chain,
})
